export { OffcanvasDirective } from './offcanvas.directive';
export { OffcanvasModule } from './offcanvas.module';
//# sourceMappingURL=index.js.map